<div class="close closeModal">
  <a (click)="close()" title="cerrar"
  *ngIf = !estaFacturando ><span class="cross"></span><span class="sr-only">cerrar</span></a
  >  
</div>

<ng-container *ngIf="!estaFacturando">
<div class="aviso facturacion" >
  <div class="tituloSearch">{{ 'DATOSFACTURACION' | translateV2 }}</div>
  <div class="avisoInputWrap" [formGroup]="facturacionForm">
    <div class="form-group">
      <div class="tit-form-group">
        <label for="nombre">{{ 'NOMBRE_RAZONSOCIAL' | translateV2 }}</label>
      </div>
      <input
        category="ALFANUMERICO"
        (focus)="focusValue($event)"
        type="text"
        class="form-control"
        id="nombre"
        formControlName="nombre"
        (change)= "onChanges()"
      />
      <img class="svg" src="assets/img/icon-search.svg" alt="icono search" (click)="abrirBusqueda(true)" />
      <div class="BuscarClienteFacturacion" *ngIf="abrirFormularioBusqueda()" style="width:100%">
        <div class="inpuSearch">
          <input type="text" id="search_field" formControlName="search_field" />
          <div class="close" (click)="abrirBusqueda(false)">
            <a title="borrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
          </div>
        </div>
        <div class="listaPredicc" *ngIf="clientes">
          <div class="Rtable">
            <div class="Rtable-row Rtable-row--head">
              <div class="Rtable-cell codigo-cell column-heading">{{ 'CLIENTE_CODIGO' | translate}} </div>
              <div class="Rtable-cell cliente-cell column-heading"> {{ 'CLIENTE_NOMBRE' | translate}}</div>
              <div class="Rtable-cell legal-cell column-heading"> {{ 'CLIENTE_DENOMINACION_LEGAL' | translate}}</div>
              <div class="Rtable-cell num-cell column-heading">{{ 'CLIENTE_DNI_CIF' | translate}}</div>
            </div>
            <div
              class="Rtable-row"
              (click)="seleccionarCliente(cliente)"
              *ngFor="let cliente of pagedItems">
              <div class="Rtable-cell codigo-cell">
                <div class="Rtable-cell--content codigo-content">{{cliente.Codigo}}</div>
              </div>
              <div class="Rtable-cell cliente-cell">
                <div class="Rtable-cell--content cliente-content">{{cliente.NombreCliente | slice:0:30}}</div>
              </div>
              <div class="Rtable-cell legal-cell">
                <div class="Rtable-cell--content legal-content">{{cliente.NombreClienteFiscal}}</div>
              </div>
              <div class="Rtable-cell num-cell">
                <div class="Rtable-cell--content num-content">{{cliente.CIFoDNIFiscal}}</div>
              </div>
            </div>
          </div>
          <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1">
            <li>
              <a (click)="setPage(pager.currentPage - 1)" title="Previo">
                <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
              </a>
            </li>
            <li *ngFor="let page of pager.pages">
              <a (click)="setPage(page)" [ngClass]="{ active: pager.currentPage === page }">{{
                page
              }}</a>
            </li>
            <li>
              <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
                <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <div class="tit-form-group">
          <label for="codigoLegal">{{ 'TIPOS_DOCUMENTOS' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="codigoLegal"
          formControlName="codigoLegal"
        />
      </div>
      <div class="form-group">
        <div class="tit-form-group">
          <label for="direccion">{{ 'DIRECCION' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="direccion"
          formControlName="direccion"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <div class="tit-form-group">
          <label for="ciudad">{{ 'CIUDAD' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="ciudad"
          formControlName="ciudad"
        />
      </div>
      <div class="form-group">
        <div class="tit-form-group">
          <label for="codigoPostal">{{ 'CODIGO_POSTAL' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="codigoPostal"
          formControlName="codigoPostal"
        />
      </div>
    </div>
    <input style="display: none;"
    category="ALFANUMERICO"
    (focus)="focusValue($event)"
    type="text"
    class="form-control"
    id="codigoCliente"
    formControlName="codigoCliente"
  />
    <div class="form-row">
      <div class="form-group">
        <div class="tit-form-group">
          <label for="pais">{{ 'PAIS' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="pais"
          formControlName="pais"
        />
      </div>
      <div class="form-group">
        <div class="tit-form-group">
          <label for="provincia">{{ 'PROVINCIA' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="provincia"
          formControlName="provincia"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <div class="tit-form-group">
          <label for="comentarios">{{ 'COMENTARIOS' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="comentarios"
          formControlName="comentarios"
        />
      </div>
    </div>
    <div
      class="checkboxStyled"
      style="margin-top: 3%"
      [ngClass]="{ checked: facturacionForm.controls.privacidad.value }"
    >
      <div class="center">
        <label class="label" for="privacidad">
          <input
            class="label__checkbox"
            type="checkbox"
            formControlName="privacidad"
            id="privacidad"
          />
          <span class="label__check">
            <img class="svg" src="assets/img/checkbox-mark.svg" alt="icono checkbox" />
          </span>
        </label>
      </div>
      <label class="tit-form-group" for="privacidad" style="padding: 0 45px;">
        {{ 'CLIENTE_ACEPTA_CONDICIONES' | translateV2 }}
      </label
      >
    </div>
  </div>
  <div class="faturacion-fila">
    <div class="ticket-info">
      <div class="inputControl botones">
        <button type="button" value="cancelar" class="cancelar" (click)="close()">
          {{ 'CANCELAR' | translateV2 }}
        </button>
      </div>
    </div>
    <div class="ticket-info">
      <div class="inputControl botones">
        <button
          type="button"
          value="ACEPTAR"
          class="pagar aceptar"
          (click)="facturar()"
          [disabled]="this.estaFacturando || this.facturacionForm.invalid"
        >
          {{ 'ACEPTAR' | translateV2 }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="keyboardWrap">
  <ticketing-keyboard></ticketing-keyboard>
  <ticketing-numpad></ticketing-numpad>
</div>
</ng-container>
<div class="backModal enCalendar" *ngIf="estaFacturando">
  <div class="margin d-flex justify-content-center" style="z-index: 9999;">
  <div class="lds-ring esperando">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
</div>  
